<template>
  <v-container fluid pa-0>
    <!-- FULL VIEW DIALOG -->
    <v-flex v-if="showFullView">
      <v-dialog
        :value="showFullView"
        class="ma-0 pa-0"
        persistent
        transition="dialog-bottom-transition"
      >
        <modify-mission-full-edition
          :itemSelected="itemToView"
          :optionSelected="optionSelected"
          @cancel="cancelFullView"
        />
      </v-dialog>
    </v-flex>
    <!-- MESSAGE RELOAD REQUEST -->
    <v-snackbar
      v-model="showMessageReloadRequest"
      :timeout="0"
      :top="true"
      color="grey darken-3"
      auto-height
    >
      <v-layout column>
        <v-flex>
          <v-icon left large>warning</v-icon>
          <p>
            La Minuta de Servicios ha cambiado, y es recomendado que se recarguen los datos da la consulta actual.
          </p>
        </v-flex>
        <v-flex d-flex>
          <v-btn
            color="primary"
            @click="fetchMissionsServicesIn"
          >
            <v-icon left>cloud</v-icon>
            Recargar
          </v-btn>
          <v-btn
            color="error"
            @click="cancelMessage"
          >
            <v-icon left>clear</v-icon>
            Cerrar
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <!-- DIALOG AGENCIES -->
    <v-dialog
      v-model="showAgencies"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-flex class="text-xs-center" px-2 pt-3 pb-2>
          <h2>Seleccionar Agencia</h2>
        </v-flex>
        <agencies-tree :from-section="fromSection" />
        <v-flex d-flex pa-3 mx-2>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="cancelAngeciesTree">Cancelar</v-btn>
          <v-btn color="primary" @click="agencySelectedOk" :disabled="agencySelected === null">Aceptar</v-btn>
        </v-flex>
      </v-card>
    </v-dialog>
    <!-- DIALOG ACTIONS -->
    <v-dialog
      v-model="showActions"
      max-width="500"
      persistent
    >
      <v-card width="500">
        <!-- MODIFY -->
        <v-flex v-if="actionSelected === 0" pa-4>
          <modify-mission
            :itemSelected="itemMissionSelected"
            @finishAction="finishAction"
            @cancelAction="cancel"
          />
        </v-flex>
        <!-- TERMINATE -->
        <v-flex v-if="actionSelected === 1" pa-4>
          <terminate-mission
            :itemSelected="itemMissionSelected"
            :requestPendingToUpdate="requestPendingToUpdate"
            @reload="fetchMissionsServicesIn"
            @finishAction="finishAction"
          />
        </v-flex>
        <!-- DELETE -->
        <v-flex v-if="actionSelected === 2" pa-4>
          <delete-mission
            :itemSelected="itemMissionSelected"
            :requestPendingToUpdate="requestPendingToUpdate"
            @reload="fetchMissionsServicesIn"
            @finishAction="finishAction" />
        </v-flex>
        <!-- CLOSE -->
        <v-flex>
          <v-btn
            color="primary"
            style="top:10px;"
            absolute
            top
            right
            depressed
            small
            fab
            @click="cancel"
          >
            <v-icon>clear</v-icon>
          </v-btn>
        </v-flex>
      </v-card>
    </v-dialog>
    <!-- CONTENT -->
    <v-layout column>
      <v-card class="pb-3">
        <v-toolbar class="pr-2" color="grey darken-3" flat>
          <v-toolbar-title>Visualización Minutas de Servicio</v-toolbar-title>
          <v-flex 
            v-if="requestPendingToUpdate" 
            class="message-reload-pending" 
            ml-5
            pl-3
          >
            <v-flex d-inline-flex align-center>
              <v-flex>
                <v-icon left color="grey darken-3">warning</v-icon>
              </v-flex>
              <v-flex class="caption font-weight-medium">
                Requerde que la Minuta de Servicios ha cambiado, y es recomendado que se recarguen los datos de la consulta actual.
              </v-flex>
              <v-flex>
                <v-btn
                  flat
                  icon
                  color="grey darken-3"
                  @click="fetchMissionsServicesIn"
                >
                  <v-icon>replay</v-icon>
                </v-btn>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-toolbar>
        <v-flex d-flex>
          <!-- ************* -->
          <!-- LEFT SIDE -->
          <!-- ************* -->
          <v-flex style="max-width:350px;min-width:350px;" pa-3>
            <!-- SELECT TYPE -->
            <v-flex>
              <v-autocomplete
                v-model="requestType"
                label="Elegir tipo de consulta"
                :items="items"
                item-text='text'
                item-value='value'
                autocomplete
                box
                @change="requestTypeChanged"
              ></v-autocomplete>
            </v-flex>
            <!-- AGENCIE SELECTED -->
            <v-flex v-if="requestType === 0 && agencySelected !== null" mt-2 pb-2>
              <v-flex d-inline-flex align-baseline px-1>
                <v-flex>
                  <v-icon>business</v-icon>
                </v-flex>
                <v-flex d-inline-flex align-baseline pl-1>
                  <v-flex class="caption">
                    Agencia:
                  </v-flex>
                  <v-flex pl-1>
                    <h3>{{ agencySelected.name }}</h3>
                  </v-flex>
                </v-flex>
              </v-flex>
              <v-flex pt-1 mx-1>
                <v-btn
                  color="primary"
                  block
                  @click="showAgencies = true"
                >
                  <v-icon left>business</v-icon>
                  Cambiar Agencia
                </v-btn>
              </v-flex>
            </v-flex>
            <!-- SEARCH VEHICLE -->
            <v-flex v-if="requestType === 1" mt-3 pb-2>
              <v-text-field
                v-model="searchVehicleValue"
                ref="search"
                flat
                box
                prepend-inner-icon="search"
                color="white"
                label="Código/Sigla ó Placa"
                @keyup.enter="searchVehicle"
                @change="searchVehicle">
              </v-text-field>
              <v-flex v-if="showOk">
                <v-icon color="green">check_circle</v-icon> Vehículo Disponible
              </v-flex>
              <v-flex v-else-if="showStop">
                <v-icon color="red">not_interested</v-icon> Vehículo No Disponible
              </v-flex>
            </v-flex>
            <!-- DATE & TIME -->
            <v-flex
              v-if="requestType !== null && (searchVehicleResult.length > 0 || agencieSelectedFinal)"
              px-1
              mt-3
              mb-2
            >
              <!-- DATE INTERVAL FOR DATE1 & DATE2 -->
              <v-flex>
                <v-menu
                  v-model="menu0"
                  ref="menu0"
                  transition="scale-transition"
                  :close-on-content-click="false"
                  :return-value.sync="dates"
                  offset-x
                  left
                  full-width
                  origin="top left"
                  nudge-right="300"
                  nudge-top="-40"
                  color="white"
                >
                  <template v-slot:activator="{ on }">
                    <v-combobox
                      v-model="dates"
                      multiple
                      chips
                      small-chips
                      :label="requestType === 0 ? 'Fecha Inicio' : 'Intervalo de Fechas'"
                      :placeholder="requestType === 0 ? 'Escoger el día a consultar' : 'Escoger las fechas'"
                      prepend-inner-icon="event"
                      readonly
                      color="white"
                      clearable
                      box
                      v-on="on"
                      @click:clear="initData"
                      @click="comboClick"
                    ></v-combobox>
                  </template>
                  <v-date-picker
                    v-model="dates"
                    multiple
                    no-title
                    scrollable
                    color="blue accent-3"
                    reactive
                    locale="es-sp"
                    :first-day-of-week="1"
                    :allowed-dates="requestType === 0 ? allowedDates0 : allowedDates1"
                    @input="changesDate0"
                  >
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="menu0 = false">Cancelar</v-btn>
                    <v-btn color="primary" @click="acceptDate0">Aceptar</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <!-- MENU TIME 1 DATE 1 -->
              <v-flex v-if="showInitialTime0 && dates.length > 0">
                  <!-- :disabled="eventsLoaded" -->
                  <!-- class="mx-1" -->
                  <!-- nudge-top="300" -->
                  <!-- nudge-left="-10" -->
                <v-menu
                  ref="time1Date1Menu0"
                  lazy
                  :close-on-content-click="false"
                  v-model="time1Date1Menu0"
                  transition="scale-transition"
                  offset-x
                  left
                  full-width
                  allow-overflow
                  min-width="290px"
                  origin="top left"
                  nudge-right="750"
                  nudge-bottom="0"
                  :return-value.sync="time1Date10"
                >
                    <!-- :disabled="eventsLoaded" -->
                  <v-text-field
                    slot="activator"
                    :label="requestType === 0 ? 'Hora Inicial' : `Hora Inicial en ${dates[0]}`"
                    placeholder="Seleccionar Hora"
                    v-model="time1Date10"
                    prepend-inner-icon="av_timer"
                    readonly
                    box
                    hide-details
                    color="white"
                  />
                  <v-time-picker
                    landscape
                    v-model="time1Date10"
                    format="24hr"
                    scrollable
                    color="teal darken-1"
                    header-color="grey darken-4"
                    @input="changeTime10"
                  >
                    <!-- @change="$refs.time1Date1Menu.save(time1Date1)" -->
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="time1Date1Menu0 = false">Cancelar</v-btn>
                    <v-btn color="primary" @click="acceptTime10">Aceptar</v-btn>
                  </v-time-picker>
                </v-menu>
              </v-flex>
              <!-- TIME 2 DATE 1 MENU -->
              <v-flex v-if="showFinalTime0 && dates.length > 0" mt-3>
                  <!-- :disabled="eventsLoaded" -->
                  <!-- class="mx-1" -->
                  <!-- nudge-top="-15" -->
                <v-menu
                  ref="time2Date1Menu0"
                  lazy
                  :close-on-content-click="false"
                  v-model="time2Date1Menu0"
                  transition="scale-transition"
                  offset-x
                  left
                  full-width
                  min-width="290px"
                  origin="top left"
                  nudge-right="750"
                  nudge-bottom="0"
                  :return-value.sync="time2Date10"
                >
                  <!-- :disabled="eventsLoaded" -->
                  <v-text-field
                    slot="activator"
                    :label="requestType === 0 ? 'Hora Final' : `Hora Final en ${dates[1] ? dates[1] : dates[0]}`"
                    placeholder="Seleccionar Hora"
                    v-model="time2Date10"
                    prepend-inner-icon="av_timer"
                    readonly
                    box
                    hide-details
                    color="white"
                  />
                  <v-time-picker
                    landscape
                    v-model="time2Date10"
                    format="24hr"
                    scrollable
                    :allowed-hours="requestType === 0 ? allowedHours0 : allowedHours1"
                    :allowed-minutes="requestType === 0 ? allowedMinutes0 : allowedMinutes1"
                    color="red darken-1"
                    header-color="grey darken-4"
                    @click:hour="hourClicked0"
                    @change="changeTime20"
                    @input="inputTime20"
                  >
                    <!-- @change="$refs.time2Date1Menu.save(time2Date1)" -->
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="time2Date1Menu0 = false">Cancelar</v-btn>
                    <v-btn color="primary" @click="$refs.time2Date1Menu0.save(time2Date10)">Aceptar</v-btn>
                  </v-time-picker>
                </v-menu>
              </v-flex>
            </v-flex>
            <!-- BUTTON -->
            <v-flex mt-4 pt-2>
              <!-- LOAD DATA -->
              <v-flex
                class="text-xs-center" 
                my-2
              >
                <v-btn
                  color="primary"
                  :loading="$loading.isLoading('fetchMissionsServices')"
                  :disabled="missionsServicesDisabled"
                  block
                  @click="fetchMissionsServicesIn"
                >
                  <v-icon left>cloud</v-icon>
                  Consultar Datos
                </v-btn>
              </v-flex>
              <!-- CLEAR FORM -->
              <v-flex
                v-if="requestMissionsServices"
                class="text-xs-center"
              >
                <v-btn
                  color="red"
                  block
                  @click="initAll"
                >
                  <v-icon left>clear</v-icon>
                  Limpiar Datos
                </v-btn>
              </v-flex>
            </v-flex>
          </v-flex>
          <!-- ************* -->
          <v-divider vertical></v-divider>
          <!-- ************* -->
          <!-- RIGHT SIDE -->
          <!-- ************* -->
          <!-- ALERT AUTO RELOAD -->
          <v-alert
            class="mx-3 justify-center"
            :value="showAutoReloadAlert"
            color="primary"
            transition="scale-transition"
            style="max-width:450px;min-width:350px;max-height:150px;"
          >
            <v-flex d-inline-flex align-baseline>
              <v-icon size="36px">cloud</v-icon>
              <v-progress-circular class="pl-5" indeterminate></v-progress-circular>
            </v-flex>
            <p class="pt-2" style="max-width:450px">
              Los datos de la consulta se están actualizando, según los cambios aplicados.
            </p>
          </v-alert>
          <v-flex v-if="requestMissionsServices" class="right-container" pa-3 mx-3>
            <v-flex v-if="missionsServices.length > 0">
              <v-flex d-flex mb-2>
                <h3 style="max-width:350px;">
                  Misiones encontradas: {{ missionsServices.length }}
                </h3>
                <!-- ANALYZE PARKING CONVENTION -->
                <v-flex
                  style="max-width:380px;"
                  d-inline-flex
                  align-center
                >
                  <div class="body-2">*Seguimiento de Estacionarias (SE):</div>
                  <v-icon class="pl-1" size="21" color="success">lens</v-icon>
                  <div class="caption">Activo</div>
                  <v-icon class="pl-2" size="21" color="error">lens</v-icon>
                  <div class="caption">Inactivo</div>
                </v-flex>
              </v-flex>
              <v-flex class="scroll-data-table">
                <!-- DATA TABLE -->
                <v-data-table
                  :headers="requestType === 0 ? headers0 : headers1"
                  :items="missionsServices"
                  class="elevation-1"
                  rows-per-page-text="Cantidad de filas por página:"
                  no-data-text="No se encontraron Datos relacionados."
                  no-results-text="No se encontraron Resultados relacionados."
                  :rows-per-page-items="[25, 50, 100, { text: 'Todos', value: -1 }]"
                >
                  <template v-slot:items="props">
                    <!-- SE ANALYZE PARKING -->
                    <td class="text-xs-center mx-0 px-0">
                      <v-icon
                        size="21"
                        :color="props.item.analyzeParking ? 'success' : 'error'"
                      >
                        lens
                      </v-icon>
                    </td>
                    <!-- LICENSE PLATE -->
                    <td
                      v-if="requestType === 0"
                      class="text-xs-center mx-0 px-0"
                    >
                      {{ props.item.licensePlate }}
                    </td>
                    <!-- CODE -->
                    <td
                      v-if="requestType === 0"
                      class="text-xs-center mx-0 px-0"
                    >
                      {{ props.item.code }}
                    </td>
                    <!-- AGENCY NAME -->
                    <td
                      v-if="requestType === 0"
                      class="text-xs-center mx-0 px-0">
                      {{ props.item.agencyId | agencyName }}
                    </td>
                    <!-- MISSION NAME -->
                    <td
                      class="text-xs-center"
                    >
                      {{ props.item.name }}
                    </td>
                    <!-- MISSION DESCRIPTION -->
                    <td
                      class="text-xs-center"
                    >
                      {{ props.item.description }}
                    </td>
                    <!-- START DATE -->
                    <td class="text-xs-center">{{ props.item.startDate | filterFullDate }}</td>
                    <!-- END DATE -->
                    <td class="text-xs-center">{{ props.item.endDate | filterFullDate }}</td>
                    <!-- ACTIONS -->
                    <td class="text-xs-center">
                      <v-flex 
                        :class="props.item.inProgressRemote ? 'in-progress-state' : ''" my-2
                      >
                        <v-tooltip
                          left
                          color="amber lighten-2 grey--text text--darken-3"
                        >
                          <template v-slot:activator="{ on }">
                            <v-flex
                              v-if="props.item.inProgressRemote"
                              class="text-in-progress"
                              v-on="on"
                            >
                              {{ `...${props.item.userInProgressRemote}` }}
                            </v-flex>
                          </template>
                          <span>
                            ...modificando
                            <br />
                             <b>{{ props.item.userInProgressRemote }}</b>
                          </span>
                        </v-tooltip>
                        <v-flex d-inline-flex>
                          <!-- EDIT MISSION -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-flex class="actions-buttons">
                                <v-btn
                                  :disabled="!props.item.actions.modify"
                                  small
                                  flat
                                  icon
                                  @click="modifyMission(props.item)"
                                >
                                  <v-icon
                                    color="white"
                                    small
                                    v-on="on"
                                  >
                                    edit
                                  </v-icon>
                                </v-btn>
                              </v-flex>
                            </template>
                            <span>Modificar</span>
                          </v-tooltip>
                          <!-- EARLY FINISH MISSION -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-flex class="actions-buttons">
                                <v-btn
                                  :disabled="!props.item.actions.terminate"
                                  small
                                  flat
                                  icon
                                  @click="terminateMission(props.item)"
                                >
                                  <v-icon
                                    color="white"
                                    small
                                    v-on="on"
                                  >
                                    done
                                  </v-icon>
                                </v-btn>
                              </v-flex>
                            </template>
                            <span>Terminar Anticipadamente</span>
                          </v-tooltip>
                          <!-- DELETE MISSION -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-flex class="actions-buttons">
                                <v-btn
                                  :disabled="!props.item.actions.delete"
                                  small
                                  flat
                                  icon
                                  @click="deleteMission(props.item)"
                                >
                                  <v-icon
                                    color="white"
                                    small
                                    v-on="on"
                                  >
                                    delete_forever
                                  </v-icon>
                                </v-btn>
                              </v-flex>
                            </template>
                            <span>Eliminar</span>
                          </v-tooltip>
                          <!-- VIEW MISSION -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-flex class="actions-buttons">
                                <v-btn
                                  small
                                  flat
                                  icon
                                  :loading="
                                    $loading.isLoading('gettingVehiclesInAMission')
                                    && optionSelected === 3
                                  "
                                  @click="viewMission(props.item)"
                                >
                                  <v-icon
                                    color="white"
                                    small
                                    v-on="on"
                                  >
                                    visibility
                                  </v-icon>
                                </v-btn>
                              </v-flex>
                            </template>
                            <span>Ver</span>
                          </v-tooltip>
                        </v-flex>
                      </v-flex>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-flex>
            <v-flex v-else>
              <h3>No se encontraron resultados para los datos ingresados!</h3>
            </v-flex>
          </v-flex>
        </v-flex>
        
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import AgenciesTree from '../AgenciesTree'

import TerminateMission from './ActionsMissions/TerminateMission'
import ModifyMission from './ActionsMissions/ModifyMission'
import DeleteMission from './ActionsMissions/DeleteMission'
import ModifyMissionFullEdition from './ActionsMissions/ModifyMissionFullEdition'

import { missionInProgressMixin } from '../../mixins/missionInProgressMixin.js'

export default {
  name: 'missions-viewer',
  mixins: [missionInProgressMixin],
  components: {
    DeleteMission,
    ModifyMission,
    TerminateMission,
    AgenciesTree,
    ModifyMissionFullEdition
  },
  data() {
    return {
      requestPendingToUpdate: false,
      itemMissionSelected: {},
      actionSelected: null,
      showActions: false,
      flagTimeLimit: false,
      headers0: [
        { text: 'SE', value: 'analyzeParking', align: 'center', sortable: false, width: '20' },
        { text: 'Placa', value: 'licensePlate', align: 'center', sortable: true, width: '50' },
        { text: 'Código/Sigla', value: 'code', align: 'center', sortable: false, width: '50' },
        { text: 'Grupo-Agencia', value: 'agencyId', align: 'center', sortable: true, width: '60' },
        { text: 'Nombre Misión', value: 'name', align: 'center', sortable: false, width: '100' },
        { text: 'Descripción Misión', value: 'description', align: 'center', sortable: false, width: '150' },
        { text: 'Fecha y Hora Inicio', value: 'startDate', align: 'center', sortable: false, width: '120' },
        { text: 'Fecha y Hora Fin', value: 'endDate', align: 'center', sortable: false, width: '120' },
        { text: 'Acciones', value: 'actions', align: 'center', sortable: false, width: '200' }
      ],
      headers1: [
        { text: 'SE', value: 'analyzeParking', align: 'center', sortable: false, width: '20' },
        { text: 'Nombre Misión', value: 'name', align: 'center', sortable: false, width: '100' },
        { text: 'Descripción Misión', value: 'description', align: 'center', sortable: false, width: '150' },
        { text: 'Fecha y Hora Inicio', value: 'startDate', align: 'center', sortable: true, width: '120' },
        { text: 'Fecha y Hora Fin', value: 'endDate', align: 'center', sortable: false, width: '120' },
        { text: 'Acciones', value: 'actions', align: 'center', sortable: false, width: '200' }
      ],
      // headers0A: [
      //   { text: 'Placa', value: 'licensePlate', align: 'center', sortable: true, width: '50' },
      //   { text: 'Código/Sigla', value: 'code', align: 'center', sortable: false, width: '50' },
      //   { text: 'Grupo-Agencia', value: 'agencyId', align: 'center', sortable: true, width: '60' },
      //   { text: 'Nombre Misión', value: 'name', align: 'center', sortable: false, width: '100' },
      //   { text: 'Descripción Misión', value: 'description', align: 'center', sortable: false, width: '150' },
      //   { text: 'Fecha y Hora Inicio', value: 'startDate', align: 'center', sortable: false, width: '120' },
      //   { text: 'Fecha y Hora Fin', value: 'endDate', align: 'center', sortable: false, width: '120' },
      //   { text: 'Acciones', value: 'actions', align: 'center', sortable: false, width: '200' }
      // ],
      // headers1A: [
      //   { text: 'Nombre Misión', value: 'name', align: 'center', sortable: false, width: '100' },
      //   { text: 'Descripción Misión', value: 'description', align: 'center', sortable: false, width: '150' },
      //   { text: 'Fecha y Hora Inicio', value: 'startDate', align: 'center', sortable: true, width: '120' },
      //   { text: 'Fecha y Hora Fin', value: 'endDate', align: 'center', sortable: false, width: '120' },
      //   { text: 'Acciones', value: 'actions', align: 'center', sortable: false, width: '200' }
      // ],
      date10: null,
      date20: null,
      // showClearForm: false,
      agencieSelectedFinal: false,
      fromSection: 'missions-viewer',
      showAgencies: false,
      searchVehicleResult: [],
      showOk: false,
      showStop: false,
      searchVehicleValue: null,
      amountOfHours: 12,
      dates: [],
      items: [
        {value: 0, text: 'Por Agencia'},
        {value: 1, text: 'Por Vehículo'}
      ],
      requestType: null,
      time2Date10: null,
      time2Date1Menu0: false,
      showFinalTime0: false,
      time1Date1Menu0: false,
      showInitialTime0: false,
      time1Date10: null,
      // dates0: [],
      menu0: false,
      tempDataModifying: {},
      showFullView: false,
      itemToView: {},
      optionSelected: null
    }
  },
  watch: {
    time2Date10(newValue) {
      // console.log('time2Date10 newValue', newValue)
      if (newValue !== null && this.requestType === 0) {
        if (newValue === this.time1Date10) {
          const dateTime1 = this.$moment(`${this.date10} ${newValue}`)
          const dateTime2 = this.$moment(dateTime1).add(1, 'minutes')
          this.date20 = this.$moment(dateTime2).format('YYYY-MM-DD')
          this.time2Date10 = this.$moment(dateTime2).format('HH:mm')
        }
      } else if (newValue !== null && this.requestType === 1) {
        if (this.dates.length === 1 && newValue === this.time1Date10) {
          const dateTime1 = this.$moment(`${this.dates[0]} ${newValue}`)
          const dateTime2 = this.$moment(dateTime1).add(1, 'minutes')
          // const date1 = this.$moment(dateTime1).format('YYYY-MM-DD')
          const isDifferentDate = this.$moment(dateTime2).isAfter(dateTime1, 'day')
          if (isDifferentDate) this.dates[1] = this.$moment(dateTime2).format('YYYY-MM-DD')
          else if (this.dates.length > 1) this.dates.pop()
          this.time2Date10 = this.$moment(dateTime2).format('HH:mm')
        }
      }
    },
    dates(newValue, oldValue) {
      if (newValue.length > 1 && newValue !== oldValue) {
        const datesSort = newValue.sort()
        this.dates = datesSort
      }
    }
  },
  computed: {
    ...mapGetters([
      'showMessageReloadRequest',
      'requestMissionsServices',
      'missionsServices',
      'agencySelected',
      // 'pusherRef',
      'showAutoReloadAlert'
    ]),
    ...mapGetters({
      adminRole: 'auth/adminRole'
    }),
    missionsServicesDisabled() {
      let result = true
      if (this.dates.length > 0 && this.time1Date10 && this.time2Date10) result = false
      return result
    }
  },
  methods: {
    ...mapActions([
      'setShowMessageReloadRequest',
      'initMissionsServices',
      'fetchMissionsServices',
      'agencySelectedAction',
      'searchVehicleAction',
      'getVehiclesInAMission'
    ]),
    cancelMessage() {
      this.requestPendingToUpdate = true
      this.setShowMessageReloadRequest(false)
    },
    cancel() {
      this.triggerActionBlock(this.tempDataModifying, false)
      this.tempDataModifying = {}
      this.showActions = false
      this.actionSelected = null
    },
    finishAction() {
      this.tempDataModifying = {}
      this.showActions = false
      this.actionSelected = null
    },
    modifyMission(data) {
      // console.log('MODIFY MISSION: ', data)
      this.tempDataModifying = data
      this.triggerActionBlock(data, true)
      this.itemMissionSelected = data
      this.actionSelected = 0
      this.showActions = true
    },
    terminateMission(data) {
      // console.log('TERMINATE MISSION: ', data)
      this.tempDataModifying = data
      this.triggerActionBlock(data, true)
      this.itemMissionSelected = data
      this.actionSelected = 1
      this.showActions = true
    },
    deleteMission(data) {
      // console.log('DELETE MISSION: ', data)
      this.tempDataModifying = data
      this.triggerActionBlock(data, true)
      this.itemMissionSelected = data
      this.actionSelected = 2
      this.showActions = true
    },
    inputTime20(value) {
      this.$nextTick(() => {
        // console.log('INPUT TIME 2', this.time2Date10, value)
        const time1 = new Date(`${this.date10} ${this.time1Date10}`)
        const time2 = new Date(`${this.date20} ${this.time2Date10}`)
        const diffTime = Math.abs(time2 - time1)
        const compareTime = this.amountOfHours * 3600 * 1000
        // console.log(time1, time2, diffTime, compareTime)
        if (diffTime > compareTime && this.requestType === 0) {
          this.time2Date10 = `${value.split(':')[0]}:00`
          this.flagTimeLimit = true
        }
      })
    },
    initAll() {
      this.initSelections()
      this.initData()
      this.requestType = null
      this.requestPendingToUpdate = false
      this.setShowMessageReloadRequest(false)
    },
    initSelections() {
      this.agencySelectedAction(null)
      this.agencieSelectedFinal = false
      this.showAgencies = false
      this.searchVehicleResult = []
      this.showOk = false
      this.showStop = false
      this.searchVehicleValue = null
    },
    fetchMissionsServicesIn() {
      // console.log('fetchMissionsServicesIn')
      this.requestPendingToUpdate = false
      this.setShowMessageReloadRequest(false)
      let startDate = ''
      let endDate = ''
      const payload = {
        startDate,
        endDate
      }

      if (this.requestType === 0) {
        payload.startDate = `${this.date10} ${this.time1Date10}`
        payload.endDate = `${this.date20} ${this.time2Date10}`
        payload.agencyId = this.agencySelected.agencyId
      } else if (this.requestType === 1) {
        const dateAlt = this.dates.length === 2 ? this.dates[1] : this.dates[0]
        payload.startDate = `${this.dates[0]} ${this.time1Date10}`
        payload.endDate = `${dateAlt} ${this.time2Date10}`
        payload.vehicleId = this.searchVehicleResult[0].id
      }

      this.fetchMissionsServices(payload)
    },
    cancelAngeciesTree() {
      this.showAgencies = false
      this.requestType = null
      this.initData()
    },
    agencySelectedOk() {
      this.showAgencies = false
      this.agencieSelectedFinal = true
    },
    requestTypeChanged() {
      this.initData()
      this.initSelections()
      if (this.requestType === 0) this.showAgencies = true
    },
    searchVehicle() {
      // console.log('SEARCH', this.searchVehicleValue)
      if (this.searchVehicleValue !== null) {
        this.searchAction = false
        this.searchVehicleAction(this.searchVehicleValue)
          .then(result => {
            // this.searchVehicleValue = null
            this.searchAction = true
            // this.$refs.search.reset()
            this.searchVehicleResult = result
            // console.log('searchVehicleResult ', this.searchVehicleResult)
            if (this.searchVehicleResult.length > 0) {
              this.showOk = true
              this.showStop = false
            } else {
              this.showOk = false
              this.showStop = true
            }
            // console.log('RESULT', this.searchVehicleResult)
          })
      }
    },
    allowedMinutes1(value) {
      // console.log('allowedMinutes1', value)
      if (this.dates.length === 1) {
        if (this.time2Date10 !== null) {
          const startHour = this.time1Date10.split(':')
          const selectedHour = this.time2Date10.split(':')
          if (Number(startHour[0]) === Number(selectedHour[0])) {
            if (value > Number(startHour[1])) return true
            else return false
          } else return true
        }
      } else return true
    },
    allowedHours1(value) {
      let allowedHour1 = true
      if (this.dates.length === 1) {
        const selectedHour = this.time1Date10.split(':')
        if (value < Number(selectedHour[0])) allowedHour1 = false
      }
      return allowedHour1
    },
    initData() {
      this.initMissionsServices()
      // this.agencySelectedAction(null)
      // this.showClearForm = false
      this.dates = []
      // this.agencieSelectedFinal = false
      // this.showAgencies = false
      // this.searchVehicleResult = []
      // this.showOk = false
      // this.showStop = false
      // this.searchVehicleValue = null
      this.showInitialTime0 = false
      this.showFinalTime0 = false
      this.onlyDate10 = null
      this.onlyDate20 = null
      this.date10 = null
      this.date20 = null
      this.limitTime0 = null
      this.limitHour0 = null
      this.limitMinute0 = null
      this.time1Date1Menu0 = false
      this.time1Date10 = null
      this.time2Date1Menu0 = false
      this.time2Date10 = null
    },
    changeTime20() {
      // console.log('CHANGE TIME 2', this.time1Date10, this.time2Date10)
      this.flagTimeLimit = false
      // const startTime = this.$moment(this.time1Date10, 'HH:mm')
      // const finalTime = this.$moment(this.time2Date10, 'HH:mm')
      // console.log('startTime: ', startTime)
      // console.log('finalTime: ', finalTime)
      // const differenceTime = this.$moment.startTime.diff(finalTime, 'hours')
      // console.log('DIFF: ', differenceTime)
    },
    hourClicked0(value) {
      // console.log('HOUR CLICKED', value)
      this.flagTimeLimit = false
    },
    allowedMinutes0(value) {
      if (this.time2Date10 !== null) {
        const startHour = this.time1Date10.split(':')
        const selectedHour = this.time2Date10.split(':')
        if (Number(selectedHour[0]) === Number(this.limitHour0)) {
          if (value <= this.limitMinute0) return true
          else return false
        } else if (Number(startHour[0]) === Number(selectedHour[0])) {
          if (value > Number(startHour[1])) return true
          else return false
        }
      }
      return true
    },
    allowedHours0(value) {
      // console.log('allowedHours0', value)
      const myDate = `${this.dates[0]} ${this.time1Date10}`
      this.date10 = this.dates[0]

      if (this.time2Date10) {
        const selectedHour1 = this.time1Date10.split(':')
        const selectedHour2 = this.time2Date10.split(':')
        let myDate2 = null

        if (Number(selectedHour2[0]) < Number(selectedHour1[0]) && this.onlyDate10 !== this.onlyDate20) myDate2 = this.onlyDate20
        else myDate2 = this.dates[0]

        this.date20 = this.$moment(myDate2).format('YYYY-MM-DD')
      }

      const allowedHoursArray = []
      for (let i = 0; i <= this.amountOfHours; i++) {
        const h = this.$moment(myDate).add(i, 'hours').format('H')
        allowedHoursArray.push(Number(h))
      }

      this.limitTime0 = this.$moment(myDate).add(this.amountOfHours, 'hours').format('YYYY-MM-DD HH:mm:ss')
      this.onlyDate10 = this.$moment(myDate).format('YYYY-MM-DD')
      this.onlyDate20 = this.$moment(myDate).add(this.amountOfHours, 'hours').format('YYYY-MM-DD')
      this.limitHour0 = this.$moment(this.limitTime0).format('H')
      this.limitMinute0 = this.$moment(this.limitTime0).format('mm')

      const isIn = allowedHoursArray.filter(item => item === value)
      if (isIn.length > 0) {
        return true
      } else return false
    },
    acceptTime10() {
      this.$refs.time1Date1Menu0.save(this.time1Date10)
      this.time2Date10 = this.time1Date10
      this.showFinalTime0 = true
    },
    changeTime10() {
      // console.log('CHANGE TIME 10')
      this.time2Date10 = null
    },
    acceptDate0() {
      this.$refs.menu0.save(this.dates)
      this.time1Date10 = '00:00'
      this.showInitialTime0 = true
    },
    changesDate0() {
      // console.log('CHANGE DATE')
      this.date10 = this.dates[0]
      this.date20 = this.dates[0]
      if (this.dates.length === 1) {
        this.time2Date10 = null
      }
    },
    allowedDates1(date) {
      // let today = this.$moment.now()
      let datesResult = this.$moment(date).isAfter('2020-03-31')
      // today = this.$moment(today).format('YYYY-MM-DD')

      if (this.dates.length === 1) {
        const dayBefore = this.$moment(this.dates[0]).subtract(7, 'days').format('YYYY-MM-DD')

        const dayAfter = this.$moment(this.dates[0]).add(7, 'days').format('YYYY-MM-DD')
        // datesResult = date > dayBefore && date === this.dates[0] && date < dayAfter
        if (this.dates[0] <= '2020-04-07') datesResult = date >= '2020-04-01' && date < dayAfter
        else datesResult = date > dayBefore && date < dayAfter
      } else if (this.dates.length === 2) {
        datesResult = date === this.dates[0] || date === this.dates[1]
      }

      return datesResult
    },
    allowedDates0(date) {
      let datesResult = this.$moment(date).isAfter('2020-03-31')

      if (this.dates.length === 1) datesResult = date === this.dates[0]

      return datesResult
    },
    comboClick() {
      // console.log('COMBO CLICK')
      if (this.requestType === 1) {
        const temp = this.dates
        this.dates = []
        temp.forEach(element => {
          this.dates.push(element)
        })
        this.allowedDates1(this.dates[0])
      }
    },
    async viewMission(data) {
      // console.log('VIEW MISSION', data)
      this.optionSelected = 3
      await this.getVehiclesInAMission(data.missionID)
      this.itemToView = data
      this.showFullView = true
    },
    cancelFullView() {
      this.showFullView = false
      this.itemToView = {}
      this.optionSelected = null
    }
  },
  activated() {
    this.initAll()
  }
}
</script>

<style lang="stylus" scoped>
.message-reload-pending
  color #424242
  background-color #FFB300
  border-radius 3px
  max-width 340px
  height 45px
  line-height 11px

.actions-buttons
  width 32px

.scroll-data-table
  height calc(100vh - 270px)
  overflow-y scroll

.right-container
  // max-width 1200px
  // min-width 1200px
  background-color #212121
  border-radius 3px

.in-progress-state
  // background-color #FFD54F
  border dashed 1px #FFD54F
  border-radius 10px
  max-width 105px
  min-width 105px
  max-height 50px
  min-height 50px

.text-in-progress
  background-color #FFD54F
  border-radius 10px 10px 0 0
  font-size 9px
  text-align center
  color #212121
  // color white
  max-width 103px
  min-width 103px
  max-height 14px
  min-height 14px
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

</style>



// WEBPACK FOOTER //
// src/components/Missions/MissionsViewer.vue